 import React, { Component } from "react";
import { Navigate } from "react-router-dom"; // Import Navigate

import UserTables from "../pages/Tables/DataTables/UserTables";
import Login from "../pages/Authentication/Login";
import CurateDataTable from "../pages/Tables/DataTables/CurateData";
import MasterDataTable from '../pages/Tables/DataTables/MasterData';
import ChapterConfig from '../pages/Tables/DataTables/ChapterConfigData';
import CurateProduct from "../pages/Tables/DataTables/CurateProduct";
import CompanyDataTable from '../pages/Tables/DataTables/CompanyData';
import ConfigureProductTable from '../pages/Tables/DataTables/ConfigureProductData';
import { VerificationProductData } from "../pages/Tables/DataTables/VerficationProductData";
import VerificationPortal from "../pages/Tables/DataTables/VerificationPortal";
import FdfMasterData from "../pages/Tables/DataTables/FdfMasterData";
import ShipmentValidator from "../pages/Tables/DataTables/ShipmentValidator";
import ValidationHistoryPage from "../pages/Tables/DataTables/ValidationHistoryPage";

const token = localStorage.getItem("token");
const user = JSON?.parse(localStorage.getItem("user"));

const publicRoutes = [{ path: "/login", component: Login},
  {
    path: "/",
    exact: true,
    component: () => {
      const token = localStorage.getItem("token");
      return token ? <Navigate to="/data-curation" /> : <Navigate to="/login" />;
    },
  }
];

const adminAuthProtectedRoutes = [
  { path: "/users", component: UserTables, roles:['admin', 'superadmin'] },
  { path: "/data-curation", component: CurateDataTable, roles:['user', 'admin', 'superadmin'] },
  { path: "/company-curation", component: CompanyDataTable, roles:['user', 'admin', 'superadmin'] },
  { path: "/curate-product", component: CurateProduct, roles:['user', 'viewuser','admin', 'superadmin'] },
  { path: "/master-data", component: MasterDataTable, roles:['user', 'viewuser', 'admin', 'superadmin'] },
  { path: "/fdf-master", component: FdfMasterData, roles:['user', 'viewuser', 'admin', 'superadmin'] },
  { path: '/chapter-config' ,component: ChapterConfig, roles:['user', 'viewuser', 'admin', 'superadmin']},
  {path :'/config-product' , component: ConfigureProductTable, roles:['user', 'admin', 'superadmin']},
  //{path :'/verification' , component: VerificationProductData, roles:['user', 'admin', 'superadmin']},
  {path :'/validate' , component: ShipmentValidator, roles:['user', 'admin', 'superadmin']},
  {path :'/validation-history' , component: ValidationHistoryPage, roles:['user', 'admin', 'superadmin']},
  //{path :'/verification/:fileId/:id' , component: VerificationPortal, roles:['user', 'admin', 'superadmin']},
  {
    path: "/",
    exact: true,
    component: () => {
      if (token) {
        if (user.role === "viewuser") {
          return <Navigate to="/fdf-master" />
        } else {
          return <Navigate to="/data-curation" /> 
        }
      }
      return <Navigate to="/login" />;
    },
  }
];

const customerAuthProtectedRoutes = [
  { path: "/data-curation", component: CurateDataTable, roles: ['user', 'viewuser'] },
  { path: "/company-curation", component: CompanyDataTable, roles: ['user', 'viewuser']  },
  { path: "/curate-product", component: CurateProduct, roles: ['user', 'viewuser']  },
  { path: "/fdf-master", component: FdfMasterData, roles: ['user', 'viewuser']},
  {
    path: "/",
    exact: true,
    component: () => {
      if (token) {
        if (user.role == "viewuser") {
          return <Navigate to="/fdf-master" />
        } else {
          return <Navigate to="/data-curation" /> 
        }
      }
      return <Navigate to="/login" />;
    },
  }
];

export { adminAuthProtectedRoutes,customerAuthProtectedRoutes, publicRoutes };
